/* src/app/modules/shared/components/header-column/header-column-product-title/header-column-product-title.component.scss */
app-header-column-product-title {
  display: contents;
}
/*# sourceMappingURL=header-column-product-title.component.css.map */
